import { Button } from '@/components/ui/button';
import { Wallet, HandCoins } from 'lucide-react';

const fmt = (n) => (n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Pre-payment loan & advance position with a one-tap "Apply deduction".
 * `deductions` shape comes from /salary-alerts | /partner-payment-alerts.
 * onApply(recommended) lets the parent reduce the salary amount being paid.
 */
export function SalaryDeductionCard({ deductions, onApply, cur = 'SAR' }) {
  if (!deductions || !deductions.has_obligations) return null;
  const { loan_outstanding, installment_due, advance_balance, recommended_deduction } = deductions;
  return (
    <div className="rounded-lg border border-indigo-200 bg-indigo-50 p-3 space-y-2" data-testid="salary-deduction-card">
      <div className="flex items-center gap-1.5 text-[12px] font-semibold text-indigo-800">
        <Wallet size={14} /> Outstanding loan / advance
      </div>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-[11.5px] text-indigo-900">
        {loan_outstanding > 0.01 && <div className="flex justify-between"><span>Loan balance</span><strong>{cur} {fmt(loan_outstanding)}</strong></div>}
        {installment_due > 0.01 && <div className="flex justify-between"><span>Installment due</span><strong>{cur} {fmt(installment_due)}</strong></div>}
        {advance_balance > 0.01 && <div className="flex justify-between"><span>Advance balance</span><strong>{cur} {fmt(advance_balance)}</strong></div>}
        {recommended_deduction > 0.01 && <div className="flex justify-between"><span>Recommended deduction</span><strong>{cur} {fmt(recommended_deduction)}</strong></div>}
      </div>
      {recommended_deduction > 0.01 && (
        <Button type="button" size="sm" variant="outline"
                className="h-7 rounded-full text-[11px] border-indigo-300 text-indigo-700 hover:bg-indigo-100"
                onClick={() => onApply?.(recommended_deduction)} data-testid="apply-deduction-btn">
          <HandCoins size={12} className="mr-1" /> Apply deduction ({cur} {fmt(recommended_deduction)})
        </Button>
      )}
    </div>
  );
}
